export const state = {
  shopId: null,
  shopInfo: null,
  level: null,
  theme: null,
  blog: []
}



// WEBPACK FOOTER //
// ./src/store/shop/state.js